
<template>
  <div>
      <!-- 节次管理 -->
    <div><router-view /></div>
    <el-card class="box-card mb15">
      <el-row :gutter="20">
        <el-col :xs="12" :sm="8" :md="8" :lg="5">
          <el-input placeholder="请输入仪器/场地名称" v-model="listQuery.bookingEquipment" clearable></el-input>
        </el-col>
        <!-- <el-col :xs="12" :sm="8" :md="8" :lg="5">
          <el-input placeholder="请输入方案名称" v-model="listQuery.name" clearable></el-input>
        </el-col> -->
        <el-col style="float: left; width: 110px">
          <el-button type="primary" icon="el-icon-search" @click="getList()" style="width: 90px">搜索</el-button >
        </el-col>
        <!-- <el-col style="float: right; width: 110px">
          <el-button type="primary" @click="newInstrAppointment()" style="width: 90px">仪器预约</el-button >
        </el-col> -->
        <!-- <el-col style="float: right; width: 110px">
          <el-button type="primary" @click="newRoomAppointment()" style="width: 90px">会议室预约</el-button >
        </el-col> -->
      </el-row>
    </el-card>
    <el-card class="box-card mb15">
      <el-table ref="multipleTable" :data="tableData" style="width: 100%" stripe>
        <el-table-column fixed type="index" label="序号"> </el-table-column>
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column prop="type" label="类型"></el-table-column>
        <el-table-column prop="bookingName" label="创建人"> </el-table-column>
        <el-table-column prop="appointmentPeriod" label="当前开放时间段"> </el-table-column>
        <el-table-column prop="status" label="是否启用">
            <el-switch
            v-model="status"
            active-color="#13ce66"
            inactive-color="#ff4949">
            </el-switch>
        </el-table-column>
        <el-table-column label="操作" width="290px">
          <template slot-scope="scope">
            <el-button-group>
              <el-button type="success" size="mini" @click="details(scope)">设置开放时间段</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        style="margin-top: 20px"
        v-show="parseInt(pageObj.count) > 0"
        :total="parseInt(pageObj.count)"
        @change="getList"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
      />
    </el-card>
  </div>
</template>
<script>
export default {
    created(){

    },
    data(){
        return{
            listQuery:{
                page: 1,
                limit: 10,
                king:'1',
                bookingEquipment:'',
            },
            tableData:[
                {
                    name:'共享设备1',
                    type:'设备',
                    bookingName:'阿杜',
                    appointmentPeriod:'9:00-12:00',
                    status:true,
                }
            ],
            pageObj: {},
            status:true,
        }
    },
    methods:{
        //查询数据
        getList(){

        },
        //仪器预约
        newInstrAppointment(){
            //type 0 新增 1 编辑 2查看
            this.$router.push({path:'/appointment/instrumentPage',query:{type:'0'}});
        },
        //页签点击
        handleSelect(tab, event){
            this.listQuery.king=tab;
            this.getList();
        },
        //查看详情
        details(row){

        },
        //编辑
        edit(row){

        },
        //取消预约
        cancel(row){

        },

    }
}
</script>
<style scoped>
.sea-span{
  width: 20%;
}
.sea-input{
  width: 70%;
  margin-left: 10px;
}

</style>